import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useObjectByTypeAndName } from '../../../hooks/useObjectByTypeAndName';
import { AdjacentType } from '../../../types';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useObjectByTypeAndNameWidget = (props) => {
    const [adjacencyType] = useState(AdjacentType.CHILD);
    const [validTypeIds] = useState(['User']);
    const { components } = useObjectByTypeAndName({
        contextObject: props.contextCustomer,
        currentObject: props.user,
        currentObjectTypeId: 'User',
        adjacencyType: adjacencyType,
        validTypeIds: validTypeIds,
        supportedTypes: [],
        dense: false,
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "objectTypeSelector" }), components.objectTypeSelector, _jsx(Typography, { variant: "h5", children: "entitySelector" }), components.entitySelector] })), [components]);
    return {
        name: 'useObjectByTypeAndName',
        category: 'hooks',
        component,
    };
};
